import { Component, OnInit } from '@angular/core';
import * as firebase                  from 'firebase';
import {ToastController, NavParams, NavController, ModalController }                  from '@ionic/angular';
import{ Router, ActivatedRoute, NavigationExtras }             from '@angular/router';
import { DatabaseService } from '../service/database.service';

@Component({
  selector: 'app-category-filter',
  templateUrl: './category-filter.page.html',
  styleUrls: ['./category-filter.page.scss'],
  providers    : []
})
export class CategoryFilterPage implements OnInit {
  //declar tjhe glabal variables
	public selectedCategoryObject        : any = {};
  public userCategoriesViaFieldWise    : any = [];
  userFields : any = [];
	public userSubCategoriesByCategWise  : any;
	public callback                      : any;
	public selectAllProductCallback      : any;
  public userInfo                      : any;
  selectedField                        : any;
	public selectedFieldObject           : any = {};
	public userFieldCallback             : any;
	public showLoaderInHome              : boolean = true;
	public showDetails                   : boolean = false;
  public connectedData                 : any;
  public logedInUserData               : any; 
	currentPage                  : any;
	isLoggedUser                 : any;
	prodtAlbCatType              : any;
  selectedUserObject           : any;
  categoryObj                  : any;
  public userFieldList: any = [];

	constructor(
			private router: Router, 
			private route: ActivatedRoute,
			public navCtrl : NavController,
			public modalCtrl: ModalController,
			public navParams       : NavParams,
      public databaseService: DatabaseService,) {
		this.connectedData       = this.navParams.get("ConnectedData");
    this.callback            = this.navParams.get("callback");
    this.selectAllProductCallback     = this.navParams.get("selectAllProductCallback");
    this.currentPage     = this.navParams.get("currentPage");
    this.userInfo            = localStorage;
    this.selectedField = localStorage.currentFieldName;
        var self = this;
    if(self.databaseService.logedInUserData != undefined  &&  this.navParams.get("userCategoriesViaFieldWise") == "" || !this.navParams.get("userCategoriesViaFieldWise")) {
      
      self.logedInUserData = self.databaseService.logedInUserData; 
      // for Select/change filed
      if(self.logedInUserData != undefined) {
        for (var i = 0; i < self.logedInUserData["fieldIdArray"].length; i++) {
          var userfield = {
            id : self.logedInUserData["fieldIdArray"][i],
            fieldName : self.logedInUserData["fieldNameArray"][i],
          }
          if(self.userFieldList.findIndex(x=>x.id == userfield.id) == -1
          && self.userFieldList.findIndex(x=>x.fieldName == userfield.fieldName) == -1) {
            self.userFieldList.push(userfield);
          }
        }
      }
      this.userCategoriesViaFieldWise =   this.databaseService.logedInUserData["CategoryCollection"][localStorage.currentFieldKeyId];
      } else {
        this.userCategoriesViaFieldWise =  this.navParams.get("userCategoriesViaFieldWise");
      }
	}

	ngOnInit() {
    
  }
  
  userSelectField(fieldObject){
    if(fieldObject.detail.value && fieldObject.detail.value != "" && fieldObject.detail.value.fieldName) {
      this.selectedField = fieldObject.detail.value.fieldName;
      localStorage.setItem("currentFieldKeyId", fieldObject.detail.value.id);
      localStorage.setItem("currentFieldName", fieldObject.detail.value.fieldName);
      this.userCategoriesViaFieldWise =   this.databaseService.logedInUserData["CategoryCollection"][localStorage.currentFieldKeyId];

    }
  }

  getCategoryBySelectedField(fieldObject) {

    this.userCategoriesViaFieldWise =   this.databaseService.logedInUserData["CategoryCollection"][fieldObject.detail.value.keyId];
  }
	//Description :closeModal  for call back button
	closeModalWithParams(user) {
		var object = {
			user           : user,
		}
		this.modalCtrl.dismiss(user);
	}
	
	//
	closeModal() {
		let self = this;
		self.modalCtrl.dismiss();
    }
    
  /*
      @Copyright Notice:
      @(#)    
      @Type: TS   
      @For:  main-page.html.
      @Description : collapseSubCategory function for append subCategory
  */
  async collapseSubCategory(event :any, categorObject : any) {
      if(event) {
          var subCategoryContainers = document.getElementsByClassName("subCategoryForFilter") as HTMLCollectionOf<HTMLElement>;
          var currentSubCategory    = event.currentTarget.nextElementSibling;
          
          var arrowForwardAll = document.getElementsByClassName("arrow-forward-categ") as HTMLCollectionOf<HTMLElement>;
          var arrowDownAll    = document.getElementsByClassName("arrow-down-categ") as HTMLCollectionOf<HTMLElement>;
          
          var arrowForwardCurrent = (<HTMLElement>event.currentTarget.getElementsByClassName("arrow-forward-categ"))[0];
          var arrowDownCurrent = (<HTMLElement>event.currentTarget.getElementsByClassName("arrow-down-categ"))[0];
          
          var currentElementStatus  = currentSubCategory.style.display;
  
          if(subCategoryContainers != null && subCategoryContainers != undefined && currentSubCategory !=  null && currentSubCategory != undefined) {
              //one by one none all the element 
              for(var i=0;i<subCategoryContainers.length;i++) {
                  subCategoryContainers[i].style.display = "none";
                  //arrow management
                  if(arrowForwardAll[i] != undefined) {
                  	arrowForwardAll[i].style.display = "block";
                  	arrowDownAll[i].style.display = "none";
                  }
              }
          
              //used for show selected after click
              if(currentElementStatus == "block") {
                  currentSubCategory.style.display  = "none";
                  //arrow management
                  arrowDownCurrent.style.display    = "none";
                  arrowForwardCurrent.style.display = "block";
              } else {
                  currentSubCategory.style.display  = "block";
                  //arrow management
                  arrowDownCurrent.style.display    = "block";
                  arrowForwardCurrent.style.display = "none";
              }
             
              var self = this;
              
              //get the categoryId and set the selected segment 
              if(categorObject.SubCategoryCollection != undefined && categorObject.SubCategoryCollection != null) {
                for await (const iterator of categorObject.SubCategoryCollection) {
                  if(iterator) {
                    if(!iterator.sizes) {
                      self.getSizeCollection(function(isSuccess, sizes) {
                        if(isSuccess &&  sizes.length > 0) {
                          var index = categorObject.SubCategoryCollection.findIndex(x =>x.id == iterator.id) 
                          if(index != -1) {
                            categorObject.SubCategoryCollection[index]["sizes"] = sizes;
                          }
                        }
                      }, categorObject.id, iterator.id);
                    }
                  }
                }
                this.userSubCategoriesByCategWise = categorObject.SubCategoryCollection;
              
              } else {
                  this.userSubCategoriesByCategWise = [];
              }
          }
      }
  }
  
  getSizeCollection(callback, categoryId : any,  subCategoryId: any) {
   var self = this;
   var index = 0
   var object = {
        categoryKeyId    : categoryId,
        subCategoryKeyId : subCategoryId
      };
    self.databaseService.getProductSizeFromGCP(function(isSuccess, data) {
      
      if(isSuccess && data.productSizeList.length > 0 ) {
       callback(true, data.productSizeList);
      }
    }, object);
  }

	getSelectedSubCategory(categorObject : any, subCategorObject : any, productSize : any) {
		var self = this;
		if(self.prodtAlbCatType) {
        self.showLoaderInHome = false;
			  self.selectedCategoryObject = categorObject;
			  self.callback(subCategorObject, categorObject, self.selectedUserObject, self.prodtAlbCatType, self.userCategoriesViaFieldWise).then(()=>{
			      self.modalCtrl.dismiss();
			  });
		} else {
        //hold the data in variable
        self.showLoaderInHome = false;
			  self.selectedCategoryObject    = categorObject;
			  //self.userSelectedSubCategoryObject = subCategorObject;
			  //used for push the data into another page
			  self.callback(self.selectedCategoryObject, subCategorObject, self.selectedFieldObject, self.userCategoriesViaFieldWise, productSize).then(()=>{
			      self.modalCtrl.dismiss();
			  });
		}
  }
	
	//filterSellerByCategory
	filterSellerByCategory(categorObject , type) {
	      var self            = this;
	      //if(categorObject && type){
	          //set cattegory value in selectedCategoryObject variable
	          self.selectedCategoryObject = categorObject;
	          self.callback( null ,  categorObject, self.selectedUserObject, type, self.userCategoriesViaFieldWise).then(()=>{
	              self.modalCtrl.dismiss();
	          });
	      //}
    }
    
    openMyConnectionProfile(user) {
      var self = this;
      var object1 = {
        userDetails          : user
      }
      const navigationExtras: NavigationExtras = {
        state : {
          object: user
        }
      };
      //self.navCtrl.navigateForward('/connection-profile');    
      self.router.navigate(["/connection-profile"], navigationExtras);
    }
  /*
      @Copyright Notice:
      @(#)
      @Type: TS   
      @For:  create-accont.html.
      @Description : getAllProductViaCategory function for get the list of products via clicked
  */
  getAllProductViaCategory(categorObject : any) {
      var self = this;
      //get the element via id
      //self.selectAllTab = document.getElementById("selectAllProduct");
      //used for push the data into another page
      self.selectAllProductCallback(categorObject, self.selectedFieldObject, self.userCategoriesViaFieldWise).then(()=>{
          self.modalCtrl.dismiss();
      });
  }


  //for resizing
  getImageThumb(url) {
    if(url.indexOf("NEWTHUMB") != -1 && url.indexOf("products%2F") != -1){
      // replacing current image to 128KB version of image - by opening thumb_128_ version
      //url = url.replace('products%2F', 'products%2Fthumb%4064_');
      //url = url.replace('products%2F', 'products%2Fthumb%40128_');//128x128px
      url = url.replace('products%2F', 'products%2Fthumb%40256_');//256x256px
    }else if(url.indexOf("NEWTHUMB") != -1 && url.indexOf("users%2F") != -1){
      //url = url.replace('users%2F', 'users%2Fthumb%4064_');
      //url = url.replace('users%2F', 'users%2Fthumb%40128_');//128x128px
      url = url.replace('users%2F', 'users%2Fthumb%40256_');//256x256px
    }
    return url;
  }
  
  //computDecodeURI function for decode the imageURL to the encode format
	computDecodeURI(url) {
		return decodeURIComponent(url);
	}

}
